import TAGSORT,{taglist} from "../class/tagsort";
import Swiper from "swiper/bundle";

const [ w, d, mq ] = [window, document, window.matchMedia("(min-width:900px)") ];

const itemTemplate =  `
  <ul class="rwd002-stock__list" :class="[ 'is-paged-' + paged ]">
    <li class="rwd002-stock__item" v-for="(article , ind) in pagedArticles">
      <a class="rwd002-stock__link" :href="article.href">
        <figure class="thumb">
          <img :src="article.thumb" :alt="article.title">
          <figcaption class="item_status" v-if="article.category.name">{{ article.category.name }}</figcaption>
        </figure>
        <p class="ttl">{{ article.title }}</p>
      </a>
    </li>
  </ul>
  `;

const relatedItemTemplate =  `
  <div class="connection-list is-related">
    <h3 class="connection-list__title" v-if="relatedArticles && relatedArticles.length > 0">関連商品</h3>
    <ul class="connection-list__inner rwd002-stock__list" v-if="relatedArticles && relatedArticles.length > 0">
      <li class="rwd002-stock__item" v-for="(article , ind) in relatedArticles">
        <a class="rwd002-stock__link" :href="article.href">
          <figure class="thumb">
            <img :src="article.thumb" :alt="article.title">
            <figcaption class="item_status" v-if="article.category.name">{{ article.category.name }}</figcaption>
          </figure>
          <p class="ttl">{{ article.title }}</p>
        </a>
      </li>
    </ul>
  </div>
  `;

const tagsList = `
  <div class="stock-tag__wrap">
    <ul id="tagListMain" class="stock-tag__main-list">
      <li class="stock-tag__main-item"><a href="/machinery/" class="stock-tag__main-link">ALL</a></li>
    </ul>
    <ul id="tagListSub" class="stock-tag__sub-list">
    </ul>
  </div>
`;

const contentLead = `
  <p class="content_lead">
    各種機械はオーバーホール・メンテナンス後に展示販売しております。<br class="pc">
    試運転、試加工につきましてもお気軽にご相談下さい。<br class="pc">
    またご購入後のアフターケアにつきましても出来る限り対応させて頂いております。
  </p>
`

class taglist_custom extends taglist {
  constructor( opt, parent ) {
    super( opt, parent );
  }
  insertContainer ( tag = `<taglist />`) {
    const container = d.querySelector( this.opt.container || '.rwd002-container');
    if( !container ) return false;
  }
}

class OPTIONS {
  constructor() {
    this.addHtml();
    this.bottomTtlClone();
    this.selectTags();
    this.detailSlide();
  }

  // 一覧カテ見出し追加
  addHtml() {
    const is_list = d.body.classList.contains('is--list');
    const contentMain = d.querySelector('.rwd002-main');
    const contentHeader = d.querySelector('.content_header');
    const relatedContainer = d.querySelector('.connection-list');
    
    if( is_list ){
      contentHeader.insertAdjacentHTML('afterend', contentLead);
      contentMain.insertAdjacentHTML('beforebegin', tagsList);
    } else {
      relatedContainer.insertAdjacentHTML('beforeend', tagsList);
    }
  }

  detailSlide() {
    const is_detail = d.body.classList.contains('is--detail');
    
    if (is_detail) {
      const mainSlideWrap = document.querySelector('.main_slide__wrap');
      const mainSlide = document.querySelector('.main_slide');
    
      if (mainSlideWrap && mainSlide) {
        // main_slideをクローンしてmain_slide__wrapの後に挿入
        const clonedSlide = mainSlide.cloneNode(true);
        mainSlideWrap.parentNode.insertBefore(clonedSlide, mainSlideWrap.nextSibling);
    
        // クローンした要素のクラスをthumb_slideに変更
        clonedSlide.classList.remove('main_slide');
        clonedSlide.classList.add('thumb_slide');
    
        // thumb_slideの初期化
        const thumbSlide = new Swiper(".thumb_slide", {
          speed: 400,
          slidesPerView: 5,
          mousewheel: false,
          breakpoints: {
            400: {
              slidesPerView: 10,
              spaceBetween: 7
            }
          }
        });
    
        // main_slideの初期化
        const mainSlideInstance = new Swiper(".main_slide", {
          loop: true,
          speed: 400,
          slidesPerView: 1,
          mousewheel: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          thumbs: {
            swiper: thumbSlide,
          }
        });
      }
    }
  }

  // 詳細タイトル売約ボタン上に複製
  bottomTtlClone() {
    const is_detail = d.body.classList.contains('is--detail');
    if( is_detail ){
      $('.rwd002-detail__head').clone().addClass('bottom_ttl').insertBefore('.last_btn');
    }
  }

  selectTags() {
    const tags = [
      ['NC・MC・EDM・特選機械', 'NC旋盤','マシニングセンター', '放電加工機・ワイヤーカット', 'その他特選機械'],
      ['旋盤・自動旋盤', '普通旋盤', '卓上旋盤', 'その他旋盤'],
      ['フライス盤・中ぐり盤・両端加工機', 'フライス盤', '中ぐり盤', '両端加工機'],
      ['ボール盤・タッピング盤', 'ラジアルボール盤', '直立ボール盤', '卓上ボール盤', 'タッピング盤'],
      ['研削盤・工具研削盤', '平面研削盤・成形研削盤', '円筒研削盤・内面研削盤', '工具研削盤', 'グラインダー・ベルトサンダー'],
      ['転造盤・その他工作機械', '転造盤', 'ブローチ盤','歯車加工機', 'その他工作機械'],
      ['鍛圧機械', 'ハンドプレス・その他プレス', 'リベッティングマシン', 'プレス・油圧プレス'],
      ['板金機械','プレスブレーキ','ベンダー', 'シャーリング', 'レーザー加工機・パンチプレス', 'パイプ加工機・その他'],
      ['バンドソー・コンターマシン・切断機', 'バンドソー', 'コンターマシン', '丸鋸切断機', 'その他切断機'],
      ['コンプレッサー・溶接機・その他機械', 'コンプレッサー', '溶接機', '木工機械', 'その他機械'],
      ['運搬機・昇降機・環境機器', 'フォークリフト・リフター', 'ホイスト・チェーンブロック', '集塵機・環境機器'],
      ['工具・測定器・周辺機器', '工作用機器', '測定機器', 'ツール・切削工具', 'その他周辺機器']
    ];

    const tagListMain = document.getElementById('tagListMain');
    const tagListSub = document.getElementById('tagListSub');

    // tagListMainへの追加
    for (const tagGroup of tags) {
      const mainItem = document.createElement('li');
      mainItem.classList.add('stock-tag__main-item');
      const mainLink = document.createElement('a');
      mainLink.href = `/machinery/?mode=list&tag=${encodeURI(tagGroup[0])}`; // エンコードしてURLに設定
      mainLink.classList.add('stock-tag__main-link');
      mainLink.textContent = tagGroup[0];
      mainItem.appendChild(mainLink);
      tagListMain.appendChild(mainItem);
    }

    // URLの検索
    const urlParams = new URLSearchParams(window.location.search);
    const encodedTag = urlParams.get('tag');
    const decodedTag = decodeURI(encodedTag); // デコードしてタグを取得

    let found = false;
    for (const tagGroup of tags) {
      if (tagGroup.some(tag => decodedTag.includes(tag))) { // デコードしたタグと比較
        for (const subTag of tagGroup.slice(1)) {
          const subItem = document.createElement('li');
          const subLink = document.createElement('a');
          subLink.href = `/machinery/?mode=list&tag=${encodeURI(subTag)}`; // エンコードしてURLに設定
          subLink.textContent = subTag;
          subLink.classList.add('stock-tag__sub-link'); // クラスを追加
          subItem.appendChild(subLink);
          tagListSub.appendChild(subItem);
        }
        found = true;
        break; // 見つかったらループを抜ける
      }
    }

    // すべて含まれていない場合
    if (!found) {
      for (const tagGroup of tags) {
        for (const subTag of tagGroup.slice(1)) {
          const subItem = document.createElement('li');
          const subLink = document.createElement('a');
          subLink.href = `/machinery/?mode=list&tag=${encodeURI(subTag)}`; // エンコードしてURLに設定
          subLink.textContent = subTag;
          subLink.classList.add('stock-tag__sub-link'); // クラスを追加
          subItem.appendChild(subLink);
          tagListSub.appendChild(subItem);
        }
      }
    }

    // currentクラスの追加
    const mainLinks = document.querySelectorAll('.stock-tag__main-link');
    let matchFound = false; // 一致フラグ

    mainLinks.forEach(link => {
      if (decodedTag === link.textContent) {
        link.classList.add('current');
        matchFound = true;
      }
    });

    const subLinks = document.querySelectorAll('.stock-tag__sub-link');
    subLinks.forEach(link => {
      if (decodedTag === link.textContent) {
        link.classList.add('current');
        matchFound = true;
      }
    });

    if (found) {
      mainLinks.forEach(link => {
        tags.forEach(tagGroup => {
          if (tagGroup[0] === link.textContent) {
            tagGroup.slice(1).forEach(subTag => {
              if (decodedTag === subTag) {
                link.classList.add('current');
                matchFound = true;
              }
            });
          }
        });
      });
    }

    // 一致するものがなかった場合、最初の"ALL"リンクにcurrentクラスを追加
    if (!matchFound && mainLinks.length > 0) {
      mainLinks[0].classList.add('current');
    }

    if(!mq.matches){
      if (tagListSub.offsetHeight > 120) {
        const slideBtn = document.createElement('button');
        slideBtn.id = 'slideBtn';
        slideBtn.className = 'stock-tag__slide-btn';
        slideBtn.textContent = 'すべてを表示';
    
        tagListSub.parentNode.insertBefore(slideBtn, tagListSub.nextSibling);
    
        slideBtn.addEventListener('click', () => {
          tagListSub.classList.toggle('open');
          slideBtn.classList.toggle('open');
          slideBtn.textContent = slideBtn.classList.contains('open') ? '閉じる' : 'すべてを表示';
        });
      }
    }
  }
}

const domReady = () => {
  
  const Tagsort = new TAGSORT({
    list: {
      itemTemplate,
      perpage: 12, // 一度に表示する記事数
    },
    related: {
      container: '.rwd002-pagination',
      itemTemplate: relatedItemTemplate
    }
  });

  d.addEventListener('tagsort.beforeInit', e => {
    const TAGSORT = e.detail;
    Tagsort.taglist = new taglist_custom( TAGSORT.opt.taglist, TAGSORT );
  });

  d.addEventListener('tagsort.afterRender', e => {
    const searchParams = new URLSearchParams( location.search );
    let queryEntries = searchParams.entries();
    let queryParamsObject = Object.fromEntries(queryEntries);
    new OPTIONS(queryParamsObject, e.detail.categories);
  });

  // Tagsort.init.then( tagsort => {  })

  Tagsort.render();
};

export default function MACHINERY () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );

  setTimeout(function(){
    const itemStatuses = document.querySelectorAll('.item_status');
    itemStatuses.forEach(item => {
      const text = item.textContent;
    
      if (text.includes('在庫有')) {
        item.classList.add('is-available');
      } else if (text.includes('商談中')) {
        item.classList.add('is-keep');
      } else if (text.includes('売却済')) {
        item.classList.add('is-unavailable');
      }
    });
  },1000);
}